import type { MRT_RowData, MRT_TableInstance } from "mantine-react-table-open";

/** Checks whether a Mantine-React-Table instance is in create mode. */
export function isMrtCreating<T extends MRT_RowData>(
  table: MRT_TableInstance<T>
) {
  return table.getState().creatingRow !== null;
}
